var path = '/app-auth/xero/xero.sign-in.html';
var html = "<span\n  data-xero-sso\n  data-layout=\"block\"\n  data-href=\"javascript:void(0)\"\n  data-label=\"{{ 'JS_SPACE.XERO.SIGN_IN' | translate }}\"\n  data-ng-click=\"$ctrl.loginWithXero()\">\n</span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;